/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import request from 'utils/request_ajax';
import { Spinner } from 'ui';
import moment from 'moment';
import DateFormat from 'constants/date_format';
import BootstrapTooltip from 'components/shared/BootstrapTooltip';
import ProgressIndicator from './ProgressIndicator';

const JourneyReportCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    request
      .get(window.location.pathname + window.location.search)
      .then(response => {
        setData(response);
      })
      .fail(err => {
        console.error(err);
      });
  }, []);

  const toLocalDate = date => {
    return moment(moment(date).format(DateFormat.fixed.ISO8601_LOCAL) + 'Z');
  };

  const formattedLocalDate = date => {
    return toLocalDate(date).format(DateFormat.MONTH_DAY_YEAR_SHORT);
  };

  const checkOverdueStatus = date => {
    if (data.completedAt) return false;
    return date && toLocalDate(date) < new Date();
  };

  return (
    <div className="JourneyReportCard JourneyReporting-main">
      {data ? (
        <div className="JourneyReportCard-content JourneyReporting-content">
          <div className="JourneyReportCard-topMsg">
            {t('journeys.report_card.for_the_assignee')}{' '}
            <span
              className="JourneyReportCard-topMsgLink"
              onClick={() => window.location.assign(`/users/${data.userId}`)}
            >
              {data.name}
            </span>{' '}
            {t('journeys.report_card.and_journey')}{' '}
            <span
              className="JourneyReportCard-topMsgLink"
              onClick={() =>
                window.location.assign(`/journey/${data.journey.id}/edit`)
              }
            >
              {data.journey.title}
            </span>
          </div>
          <table className="JourneyReportCard-table">
            <thead className="JourneyReportCard-tableHead">
              <tr>
                <th
                  className="JourneyReportCard-cell JourneyReportingTable-cell"
                  style={{ width: 40 }}
                />
                <th className="JourneyReportCard-cell JourneyReportingTable-cell">
                  {t('journeys.reporting.table_headers.name')}
                </th>
                <th className="JourneyReportCard-cell JourneyReportingTable-cell">
                  {t('journeys.reporting.table_headers.started')}
                </th>
                <th className="JourneyReportCard-cell JourneyReportingTable-cell">
                  {t('journeys.reporting.table_headers.due_by')}
                </th>
                <th className="JourneyReportCard-cell JourneyReportingTable-cell">
                  {t('journeys.reporting.table_headers.completed')}
                </th>
                <th className="JourneyReportCard-cell JourneyReportingTable-cell">
                  {t('journeys.reporting.table_headers.steps_completed')}
                </th>
                <th className="JourneyReportCard-cell JourneyReportingTable-cell">
                  {t('journeys.reporting.table_headers.progress')}
                </th>
              </tr>
            </thead>
            <tbody className="JourneyReportingTable-body">
              <tr className="JourneyReportingTable-row">
                <td
                  className="JourneyReportCard-cell JourneyReportingTable-cell"
                  style={{ width: 40 }}
                />
                <td className="JourneyReportCard-cell JourneyReportingTable-cell">
                  {data.name}
                </td>
                <td className="JourneyReportCard-cell JourneyReportingTable-cell">
                  {data.startedAt ? formattedLocalDate(data.startedAt) : '-'}
                </td>
                <td
                  className={
                    'JourneyReportingTable-cell ' +
                    (checkOverdueStatus(data.dueBy) &&
                      'JourneyReportingTable-cell--overdue')
                  }
                >
                  <div className="JourneyReportingTable-cellContent">
                    {data.dueBy ? formattedLocalDate(data.dueBy) : '-'}
                    {checkOverdueStatus(data.dueBy) && (
                      <BootstrapTooltip
                        className="ml-12"
                        tooltip="Overdue"
                        dataPlacement="top"
                        iconName="alert-circle"
                      />
                    )}
                  </div>
                </td>
                <td className="JourneyReportCard-cell JourneyReportingTable-cell">
                  {data.completedAt
                    ? formattedLocalDate(data.completedAt)
                    : '-'}
                </td>
                <td className="JourneyReportCard-cell JourneyReportingTable-cell">
                  {data.completedSteps} {t('journeys.of').toLowerCase()}{' '}
                  {data.totalSteps}
                </td>
                <td className="JourneyReportCard-cell JourneyReportingTable-cell">
                  <ProgressIndicator
                    progress={data.progress}
                    overdue={checkOverdueStatus(data.dueBy)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="JourneyReportCard-overviewText">
            {t('journeys.report_card.overview')}
          </div>
          <table className="JourneyReportCard-table">
            <thead className="JourneyReportCard-tableHead">
              <tr>
                <th className="JourneyReportCard-cell JourneyReportingTable-cell">
                  {t('journeys.reporting.table_headers.step')}
                </th>
                <th className="JourneyReportCard-cell JourneyReportingTable-cell">
                  {t('journeys.reporting.table_headers.status')}
                </th>
                <th className="JourneyReportCard-cell JourneyReportingTable-cell">
                  {t('journeys.reporting.table_headers.grade')}
                </th>
              </tr>
            </thead>
            <tbody className="JourneyReportingTable-body">
              {data.steps.map((step, idx) => {
                return (
                  <tr key={step.id} className="JourneyReportingTable-row">
                    <td className="JourneyReportCard-cell JourneyReportingTable-cell">
                      {step.title}
                    </td>
                    <td className="JourneyReportCard-cell JourneyReportingTable-cell">
                      {step.stepProgress?.completedAt
                        ? t('journeys.reporting.complete')
                        : t('journeys.reporting.incomplete')}
                    </td>
                    <td className="JourneyReportCard-cell JourneyReportingTable-cell">
                      -
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="JourneyReportCard-loader JourneysContent-loader">
          <div>
            <Spinner />
            <span className="ml-8 c-brand-gray-darker">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default JourneyReportCard;
